import { createStore } from 'vuex';
import auth from './auth'; // Ensure the auth module is correctly imported
import dashboard from './dashboard'; // Ensure the auth module is correctly imported
import projects from './projects'; // Ensure the auth module is correctly imported
import data from './data'; // Ensure the auth module is correctly imported
import goals from './goals'; // Ensure the auth module is correctly imported
import email from './email'; // Ensure the auth module is correctly imported

const store = createStore({
  modules: {
    auth, // Register the auth module
    dashboard,
    projects,
    data,
    goals,
    email
  },
  actions: {
    async initApp({ dispatch, getters }, token = null) {
      try {
        if (token) {
          await dispatch('auth/handleLoginRedirect', token);
        } else if (getters['auth/isAuthenticated']) {
          console.log('User is already authenticated.');
        } else {
          console.log('User not authenticated, staying on login page.');
          return;
        }
        // Fetch initial data if authenticated
        await dispatch('fetchProjects');
        await dispatch('getActionTypes');
        await dispatch('getInitData');
      } catch (error) {
        console.error('Error during app initialization:', error);
      }
    },
  },
  
});

export default store;
